module.exports = "/_next/static/images/Vadim_Uncu-7f2f143134f0dbb6eb921d3cdb04b301.webp";